import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import {LuminousGallery} from "luminous-lightbox";

export default class Projecten {
    constructor() {
        if (document.getElementById('portfolioShow') !== null) {
            imagesLoaded(document.getElementById('images'), function () {
                new Masonry('.grid', {
                    columnWidth: '.grid-sizer',
                    itemSelector: '.grid-item',
                    percentPosition: true,
                    gutter: 30
                });
            });

            new LuminousGallery(document.querySelectorAll(".gallery"));
        }
    }
}
